let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6D8ri")).then(() => parcelRequire('jXUXW'));